<template>
  <el-popover placement="bottom" title="" :width="400" trigger="click">
    <div class="lang-popper-content">
      <div class="type-title">{{ $t("texts.language") }}</div>
      <div class="language-btn">
        <el-button
          v-for="languageItem in languageList"
          :key="languageItem.value"
          :plain="languageItem.value != willCurrentLocale"
          @click="() => toggleLocale(languageItem)"
          :type="willCurrentLocale == languageItem.value ? 'primary' : undefined"
          class="base-ui-info"
          >
          {{ languageItem.text }}
        </el-button>
      </div>
      <div class="type-title mt-12">{{ $t("texts.currency") }}</div>
      <div class="currency-btn">
        <el-button
          v-for="currencyItem in store.currencyList"
          :key="currencyItem.toCurrencyCode"
          @click="() => toggleCurrency(currencyItem)"
          :type="
            currencyItem.toCurrencyCode == willCurrentCurrency.toCurrencyCode
              ? 'primary'
              : undefined
          "
          :plain="
            currencyItem.toCurrencyCode != willCurrentCurrency.toCurrencyCode
          "
          class="base-ui-info"
          >{{ currencyItem.toCurrencyCode }}(1:{{currencyItem.exchangeRate}})</el-button>
      </div>
      <el-button
        type="primary"
        @click="submit"
        class="base-ui-primary block w-full mt-12px"
        >{{ $t("actions.ok") }}</el-button>
    </div>
    <template #reference>
      <div @click="openLocalePopover" class="switch-wrapper ml-10px">
        <span class="icon-language-wrap">
          <LazyImage
            class="icon-language-image"
            src="/assets/imgs/transfer-lang.png"
            alt="language"
            :use-lazy="false"
            :tint-color="languageIconTintColor"
          />
        </span>
        <span class="switch-wrapper-text">
          <span class="current-locale">{{ localeText }}</span>
          <span
            v-if="get(store, 'currentCurrency.toCurrencyCode')"
            class="switch-divider-dot"
            aria-hidden="true"
          ></span>
          <span v-if="get(store, 'currentCurrency.toCurrencyCode')" class="current-currency">
            {{ get(store, "currentCurrency.toCurrencyCode") }}
          </span>
        </span>
        <el-icon class="locale-switch-arrow" :style="{ color: controlIconColor }">
          <ArrowLeft />
        </el-icon>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { ArrowLeft } from "@element-plus/icons-vue";
import { ref, computed } from "vue";
import { useMainStore } from "~/composables/store";
import { get,find } from "lodash-es";
import { $t } from "~/utils/index.js";
import LazyImage from "@/components/common/LazyImage/index.vue";
const { locale, getLocaleCookie, setLocaleCookie ,setLocale } = useI18n()
const store = useMainStore();
const props = defineProps({
  themeVars: {
    type: Object,
    default: () => ({}),
  },
});

const currentCurrency = computed(() => store.currentCurrency || {});
const willCurrentCurrency = ref(store.currentCurrency ? store.currentCurrency : {});

const languageList =computed(()=>{
  return [
    {
      text: $t("texts.chinaCn"),
      value: "zh-CN",
    },
    {
      text: $t("texts.chinaTw"),
      value: "zh-TW",
    },
    {
      text: $t("texts.en"),
      value: "en",
    },
    {
      text: $t("texts.vi"),
      value: "vi_VN",
    },
    {
      text: $t("texts.ja"),
      value: "ja_JP",
    },
  ];
});
const currentLocale = computed(() => locale.value || getLocaleCookie() || "zh-CN");
const willCurrentLocale = ref(currentLocale.value);

const localeText=computed(()=>{
  let res="";
  let findItem= find(languageList.value,(o)=>o.value==currentLocale.value);
  if(findItem){
    res=findItem.text;
  }
  return res;
});
const controlTextColor = computed(() => {
  return (
    props.themeVars?.navControlTextColor ||
    props.themeVars?.navTextColor ||
    "#44403c"
  );
});
const controlSubtleTextColor = computed(() => {
  return (
    props.themeVars?.navControlSubtleTextColor ||
    props.themeVars?.navSubtleTextColor ||
    "#57534e"
  );
});
const controlIconColor = computed(() => {
  return (
    props.themeVars?.navControlIconColor ||
    props.themeVars?.navMutedTextColor ||
    "#78716c"
  );
});
const languageIconTintColor = computed(() => {
  return controlIconColor.value || "";
});

function toggleCurrency(toCurrency) {
  willCurrentCurrency.value = toCurrency;
}

function toggleLocale(toLocale) {
 
  willCurrentLocale.value = toLocale.value;
}

async function openLocalePopover(){
  await store.getCurrencyData();
  willCurrentLocale.value = currentLocale.value;
  willCurrentCurrency.value = get(currentCurrency.value, "toCurrencyCode")
    ? currentCurrency.value
    : {};
}
async function submit() {
  const nextLocale = willCurrentLocale.value || currentLocale.value || "zh-CN";
  const currentLocaleCode = String(currentLocale.value || "zh-CN").trim();
  const currentCurrencyCode = String(
    get(currentCurrency.value, "toCurrencyCode") || ""
  ).trim().toUpperCase();
  const nextCurrencyCode = String(
    get(willCurrentCurrency.value, "toCurrencyCode") || ""
  ).trim().toUpperCase();
  const shouldReloadForLocaleChange = nextLocale !== currentLocaleCode;
  const shouldReloadForCurrencyChange =
    !!nextCurrencyCode && nextCurrencyCode !== currentCurrencyCode;

  await setLocale(nextLocale);
  setLocaleCookie(nextLocale);
  if (get(willCurrentCurrency.value, "toCurrencyCode")) {
    store.saveCurrentCurrency(willCurrentCurrency.value);
  }
  if ((shouldReloadForLocaleChange || shouldReloadForCurrencyChange) && process.client) {
    window.location.reload();
    return;
  }
  document.body.click();
}
</script>

<style scoped lang="less">
.base-ui-info.el-button--primary{
  color: #fff;
  transition: none;
}
.lang-popper-content {
  padding: 10px;
}
.switch-wrapper.is-show {
  background-color: v-bind("props.themeVars.navPanelHoverBackground || '#f5f5f4'");
  border-color: v-bind("props.themeVars.navBorderColor || '#d6d3d1'");
}

.switch-wrapper.is-show .locale-switch-arrow {
  transform: rotate(90deg);
}

.switch-wrapper:hover {
  background-color: v-bind("props.themeVars.navPanelHoverBackground || '#f5f5f4'");
  border-color: v-bind("props.themeVars.navBorderColor || '#d6d3d1'");
}

.switch-wrapper .locale-switch-arrow {
  color: v-bind("controlIconColor");
  font-size: 12px;
  transform: rotate(-90deg);
  transition: transform 0.1s linear, color 0.2s ease;
}

.lang-popper-content .type-title {
  font-size: 14px;
  line-height: 30px;
}

.lang-popper-content .currency-btn,
.lang-popper-content .language-btn {
  display: grid;
  gap: 8px 4px;
  grid-template-columns: repeat(2, 1fr);
}

.lang-popper-content .currency-btn .el-button,
.lang-popper-content .language-btn .el-button {
  font-size: 12px;
  height: 32px;
  padding: 8px;
}

.lang-popper-content .currency-btn .el-button + .el-button,
.lang-popper-content .language-btn .el-button + .el-button {
  margin-left: 0;
}

.switch-wrapper {
  align-items: center;
  /* border: 1px solid #e7e5e4;*/
  border-radius: 999px;
  -moz-column-gap: 8px;
  column-gap: 8px;
  cursor: pointer;
  display: flex;
  height: 40px;
  padding: 0 12px;
  position: relative;
  white-space: nowrap;
  background-color: #fff;
  background-color: v-bind("props.themeVars.navGhostButtonBackground || '#fff'");
  color: v-bind("controlTextColor");
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.switch-wrapper :deep(.locale-switch-arrow svg) {
  color: currentColor;
  fill: currentColor;
}
.icon-language-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: 0 0 auto;
}
.icon-language-image {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
}
.switch-wrapper-text {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.switch-divider-dot {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background-color: v-bind("props.themeVars.navDividerColor || '#d6d3d1'");
  flex: 0 0 auto;
}
.current-locale {
  display: inline-block;
  white-space: nowrap;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  line-height: 20px;
  color: v-bind("controlTextColor");
  font-weight: 500;
}
.current-currency {
  display: inline-block;
  white-space: nowrap;
  font-size: 13px;
  line-height: 20px;
  color: v-bind("controlSubtleTextColor");
  font-weight: 600;
}
</style>
